import { useQuery } from '@tanstack/react-query';
import api from '../Services/api';
import Globals from '../Globals.json';

interface NextIdPdvResponse {
  store_id: string;
  max_id_pdv: number;
  next_id_pdv: number;
}

export const useNextIdPdv = (storeId: string | number) => {
  return useQuery<NextIdPdvResponse>({
    queryKey: ['nextIdPdv', storeId],
    queryFn: async () => {
      const response = await api.get(`${Globals.api.nextIdPdv}?store_id=${storeId}`);
      return response.data;
    },
    enabled: !!storeId,
    staleTime: 0, // Sempre buscar dados frescos
    refetchInterval: false, // formulário/dado de referência: sem atualização automática
    gcTime: 0, // Não manter cache
  });
};